import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { Modal } from "react-bootstrap";

import Button from "components/Button";
import Alert from "components/Alert";
import "./IndividualPortfolioSelection.scss";

import { portfolioConstants } from "actions/types";
import { createErrorSelector, createLoadingSelector } from "store/selectors";
import type { RootState } from "types/state";

const action = portfolioConstants.UPDATE_USER_PORTFOLIO;
const loadingSelector = createLoadingSelector(action);
const errorSelector = createErrorSelector(action);

const mapStateToProps = (state: RootState) => {
  return {
    isSubmitting: loadingSelector(state),
    error: errorSelector(state),
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  onClose?: () => void;
  onSubmit?: () => void;
}

type Props = WithApolloClient<OwnProps & PropsFromRedux>;

interface State {
  selectedPortfolio: Record<string, unknown>;
  showConfirmationModal: boolean;
}

class PortfolioConfirmationModal extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      selectedPortfolio: {},
      showConfirmationModal: false,
    };
  }

  render() {
    return (
      <Modal
        centered
        scrollable
        show={true}
        onHide={this.props.onClose}
        className="contribution-modal"
      >
        <Modal.Header closeButton={false}>
          <Modal.Title className="title" id="contained-modal-title-vcenter">
            Confirm Investment Portfolio.
            <p className="confirmation-text">
              The investment portfolio you selected was not recommended by Icon.
            </p>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="modal-text">
            By selecting “I Agree” you acknowledge that you are independently
            choosing to elect a portfolio that is not recommended by Icon. The
            portfolio you selected will be managed by Icon according to the
            portfolios’ stated investment methodology which may not be suitable
            or appropriate for your financial situation, investment experience,
            investment objectives and risk tolerances. You further acknowledge
            your investment decision is made in contravention of the investment
            advice provided by Icon.
          </p>
          {this.props.error && <Alert type="error" msg={this.props.error} />}
        </Modal.Body>
        <Modal.Footer>
          <Button
            btnLabel="Cancel"
            name="cancel"
            color="cancel"
            onClick={this.props.onClose}
          />
          <Button
            btnLabel="I agree"
            name="submit"
            withArrow
            loading={this.props.isSubmitting}
            onClick={this.props.onSubmit}
          />
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connector(withApollo<Props>(PortfolioConfirmationModal));
